import { Grid, makeStyles, Typography } from '@material-ui/core';
import {
  HomePageStarredEntities,
  HomePageToolkit,
} from '@backstage/plugin-home';
import { Content, Header, Page } from '@backstage/core-components';
import DashboardIcon from '@material-ui/icons/Dashboard';
import BugReportIcon from '@material-ui/icons/BugReport';
import DescriptionIcon from '@material-ui/icons/Description';
import GitHubIcon from '@material-ui/icons/GitHub';
import CloudIcon from '@material-ui/icons/Cloud';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';

const useStyles = makeStyles(theme => ({
  container: {
    margin: theme.spacing(2, 0),
  },
  sectionTitle: {
    marginBottom: theme.spacing(1),
    fontWeight: 600,
  },
}));

const quickLinks = [
  {
    label: 'Grafana',
    url: 'https://grafana.o11y.linqapp.com',
    icon: <DashboardIcon />,
  },
  {
    label: 'Linear',
    url: 'https://linear.app',
    icon: <BugReportIcon />,
  },
  {
    label: 'Notion',
    url: 'https://www.notion.so',
    icon: <DescriptionIcon />,
  },
  {
    label: 'GitHub (linq-team)',
    url: 'https://github.com/linq-team',
    icon: <GitHubIcon />,
  },
  {
    label: 'Kubernetes',
    url: '/catalog?filters[kind]=component&filters[type]=service',
    icon: <CloudIcon />,
  },
  {
    label: 'CI/CD',
    url: '/catalog?filters[kind]=component',
    icon: <PlayArrowIcon />,
  },
];

export const HomePage = () => {
  const classes = useStyles();

  return (
    <Page themeId="home">
      <Header title="Welcome!" pageTitleOverride="Home" />
      <Content>
        <Grid container spacing={3} className={classes.container}>
          <Grid item xs={12} md={6}>
            <HomePageStarredEntities />
          </Grid>
          <Grid item xs={12} md={6}>
            <HomePageToolkit tools={quickLinks} title="Quick Links" />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" className={classes.sectionTitle}>
              Cluster & CI/CD Status
            </Typography>
            <Typography variant="body2" color="textSecondary">
              View Kubernetes workloads and CI/CD status on individual service
              entity pages via the Kubernetes and CI/CD tabs. Use the quick links
              above to browse services or visit Grafana for cluster-wide alerts
              and dashboards.
            </Typography>
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};
